import { gql } from '@apollo/client'

export default gql`
  fragment PartialListingMap on Listing {
    id
    price
    address {
      id
      lat
      lng
    }
  }
`
